module.exports = __webpack_public_path__ + "static/media/golf.d704cbd8.jpg";